// src/main.jsx - Finding Your Voice Entry Point
// Must stay first — strips hub tokens from the URL before anything reads it.
import './captureUrlSecrets.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { startAnalytics } from './services/analytics';
import './index.css';

// Consent-aware analytics: arms the helper before React mounts and loads
// Google Analytics only for a visitor who has already said yes. Runs after
// captureUrlSecrets (the first import), so no hub token is ever in the URL
// that analytics could read.
startAnalytics();

const toasterConfig = {
  position: 'top-right',
  toastOptions: {
    duration: 4000,
    style: {
      background: '#3A3632',
      color: '#F5ECD7',
      border: '1px solid rgba(212, 162, 78, 0.3)',
      borderRadius: '8px',
      fontFamily: 'Quicksand, sans-serif',
    },
    success: {
      iconTheme: {
        primary: '#D4A24E',
        secondary: '#3A3632',
      },
    },
    error: {
      iconTheme: {
        primary: '#8B4D3B',
        secondary: '#F5ECD7',
      },
    },
  },
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
        <Toaster {...toasterConfig} />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
